import axios from 'axios';
import { API_URL } from '../env';
import { normalize } from '../services/helpers';

const gameTurn = {
  draw: async (id) => {
    const response = await axios.patch(`${API_URL}/games/${id}/draw`);

    return normalize(response.data);
  },
  attach: async (id, energyPosition, benchPosition) => {
    const response = await axios.patch(`${API_URL}/games/${id}/attach`, {
      type: 'ACTIVE_POKEMON',
      energy_position: energyPosition,
      bench_position: benchPosition,
    });

    return normalize(response.data);
  },
  evolve: async (id, handPosition, benchPosition) => {
    const response = await axios.patch(`${API_URL}/games/${id}/evolve`, {
      hand_position: handPosition,
      bench_position: benchPosition,
    });

    return normalize(response.data);
  },
  bench: async (id, handPosition, benchPosition) => {
    const response = await axios.patch(`${API_URL}/games/${id}/bench`, {
      hand_position: handPosition,
      bench_position: benchPosition,
    });

    return normalize(response.data);
  },
  putBenchAsActivePokemon: async (id, benchPosition) => {
    const response = await axios.patch(`${API_URL}/games/${id}/put-bench-as-active-pokemon`, {
      bench_position: benchPosition,
    });

    return normalize(response.data);
  },
  /** benchPosition null for the active Pokémon, or when the Trainer goes on no Pokémon. */
  /** @param {object[]} picks one per step, from picksRequest */
  trainer: async (id, handPosition, picks) => {
    const response = await axios.patch(`${API_URL}/games/${id}/trainer`, {
      hand_position: handPosition,
      picks,
    });

    return normalize(response.data);
  },
  /**
   * @param {string|number} at where the Pokémon with the Power is: 'active' or a bench position
   * @param {object[]} picks one per step, from picksRequest
   */
  power: async (id, at, moveId, picks) => {
    const response = await axios.patch(`${API_URL}/games/${id}/power`, {
      bench_position: at === 'active' ? null : at,
      move_id: moveId,
      picks,
    });

    return normalize(response.data);
  },
  /** Computer Search or Pokédex, once played: the deck positions picked, in order (top card first for Pokédex). */
  look: async (id, deckPositions) => {
    const response = await axios.patch(`${API_URL}/games/${id}/look`, {
      deck_positions: deckPositions,
    });

    return normalize(response.data);
  },
  /** Clefairy Doll: discards the Trainer in play at 'active' or a bench position. */
  discardFromPlay: async (id, at) => {
    const response = await axios.patch(`${API_URL}/games/${id}/discard-from-play`, {
      bench_position: at === 'active' ? null : at,
    });

    return normalize(response.data);
  },
  switchIn: async (id, benchPosition) => {
    const response = await axios.patch(`${API_URL}/games/${id}/switch-in`, {
      bench_position: benchPosition,
    });

    return normalize(response.data);
  },
  drawPrize: async (id, prizePosition) => {
    const response = await axios.patch(`${API_URL}/games/${id}/draw-prize`, {
      prize_position: prizePosition,
    });

    return normalize(response.data);
  },
};

export default gameTurn;
